import {Permissions, RoleData} from "@/enums/user";
import {useOrg} from "@/hooks/useOrg";
import {usePermissions} from "@/hooks/usePermissions";

/**
 * GailGPT chat needs a GailGPT seat with an active organization entitlement and
 * `conversation.read`, the same gates Galactus applies to GailGPT conversations.
 */
export function useGailGptChatAccess(): {loading: boolean; allowed: boolean} {
  const {productAccess} = useOrg();
  const {canAccess} = usePermissions();
  return {
    loading: productAccess.loading,
    allowed:
      !productAccess.loading &&
      productAccess.userCanUseGailGpt &&
      canAccess(RoleData.GPT, Permissions.Read),
  };
}
